// Weekly time breakdown chart per project
import { useT } from '@/i18n/useT';
import { ProjectBreakdownBars } from './ProjectBreakdownBars';

const ProjectBreakdown = ({ projects, selectedProject, onProjectClick }) => {
  const t = useT();
  const total = projects.reduce((s, p) => s + p.hours, 0);
  if (!projects.length || total === 0) return null;
  const sorted = [...projects].sort((a, b) => b.hours - a.hours);
  const sectionLabel = t(
    'dashboard.projectTimeThisWeek',
    'Tijd per project — deze week',
  );
  const barsLabel = t('dashboard.projectBreakdownBars', 'Projectbalken');

  return (
    <ProjectBreakdownBars
      sorted={sorted}
      total={total}
      selectedProject={selectedProject}
      onProjectClick={onProjectClick}
      sectionLabel={sectionLabel}
      barsLabel={barsLabel}
    />
  );
};

export default ProjectBreakdown;
